import React from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';

import ScrollToTopOnMount from '../components/ScrollToTopOnMount';
import HomePage from '../pages/HomePage';
import CapabilitiesPage from '../pages/CapabilitiesPage';
import WorkPage from '../pages/WorkPage';
import WorkDetailPage from '../pages/WorkDetailPage';
import ErrorNotFoundPage from '../pages/ErrorNotFoundPage';

const Routes = () => (
  <Router>
    <ScrollToTopOnMount>
      <Switch>
        <Route exact path="/" component={HomePage} />
        <Route exact path="/capabilities" component={CapabilitiesPage} />
        <Route exact path="/work" component={WorkPage} />
        <Route exact path="/work/:project" component={WorkDetailPage} />
        <Route component={ErrorNotFoundPage} />
      </Switch>
    </ScrollToTopOnMount>
  </Router>
);

export default Routes;



// WEBPACK FOOTER //
// ./src/util/Routes.js